import { useUrlQueryState } from '@/common/hooks';

/**
 * A useState replacement for URL query-based modify search open state.
 * @returns The current modify search open state, and a setter function
 */
export const useModifySearchOpenState = () => useUrlQueryState('modifySearch');
